import TFSortable from '../components/custom-form/TFSortable.vue';
import TFSortableImages from '../components/custom-form/TFSortableImages.vue';

Vue.component('tf-sortable', TFSortable);
Vue.component('tf-sortable-images', TFSortableImages);
